<template>
    <div id="footer">
        <div class="company-info" :key="showHead">
            <div class="logo-box">
                <div class="logo-content">
                    <img :src="local_la['logoSrcFooter']" alt="foot-logo">
                </div>
            </div>
            <div class="about-us">
                <div class="about-content">
                    <span class="footer-title">{{ local_la['关于我们'] }}</span>
                    <span class="footer-span">{{ local_la['有限公司旗下出品'] }}</span>
                    <span class="footer-span">{{ local_la['科技赋能，为企业降低运营成本'] }}</span>
                </div>
            </div>
            <div class="contact-us">
                <div class="contact-content">
                    <span class="footer-title footer-title-1">{{ local_la['联系我们'] }}</span>
                    <div class="content-1 content-first">
                        <div class="pict-box">
                            <img src="../../static/img/ic_email.png" alt="adress" class="pict">
                        </div>
                        <span class="footer-span footer-span-1">contact@lancerai.com</span>
                    </div>
                   
                    <div class="content-1">
                        <div class="pict-box">
                            <img src="../../static/img/ic_adress.png" alt="" class="pict">
                        </div>
                        <span class="footer-span footer-span-1">{{ local_la['addr'] }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="hr-box">
            <div class="hr-line"></div>
        </div>
        <div class="company-last-info">
            <span>{{ local_la['Copyright'] }}</span>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            ZH_la: {
                "logoSrcFooter": "../../static/img/pc_logocn_top.png",
                "关于我们": "关于我们",
                "有限公司旗下出品": "有限公司旗下出品",
                "科技赋能，为企业降低运营成本": "科技赋能，为企业降低运营成本",
                "联系我们": "联系我们",
                "联系电话:": "",
                "addr": "",
                "Copyright": "Copyright ",
            },
            EN_la: {
                "logoSrcFooter": "../../static/img/pc_logoen_foot.png",
                "关于我们": "About Us",
                "有限公司旗下出品": "By Lancer Technologies Co., Limited",
                "科技赋能，为企业降低运营成本": "Enabling technology to reduce operating costs for enterprises",
                "联系我们": "Contact Us",
                "联系电话:": "",
                "addr": "FLAT/RM A 12/F ZJ 300, 300 LOCKHART ROAD, WAN CHAI, HONG KONG",
                "Copyright": "Copyright © 2021 Lancer Technologies Co., Limited",
            },
            local_la: {

            },
        }
    },
    created(){
        this.changeFooter()
    },
    methods: {
        changeFooter: function(){
            // 根据local_la确定字符串和图片的显示
            if (this.$store.state.languageState == false){
                this.local_la = this.ZH_la;
            } else {
                this.local_la = this.EN_la;
            }
        },
    },
    computed: {
        showHead: function() {
            this.changeFooter();
            return this.$store.state.languageState;
        }
    },
}
</script>

<style scoped>
#footer{
    width: 100%;
	height: 22.35vw;
	background-color: #0b0f1a;
}
.company-info{
    padding-top: 4.48vw;
    display: flex;
    align-content: space-around;
    justify-content: space-around;
}
.logo-box{
    display: flex;
    align-content: center;
    justify-content: center;
}
.logo-content{
    width: 8.85vw;
	height: auto;
}
.content-1{
    display: flex;
    align-items: baseline;
    justify-content: flex-start;
}
.content-first{
    margin-top: 1.18vw;
}
.pict-box{
    margin-top: 0.5vw;
    width: 1.29vw;
	height: auto;
    display: flex;
    align-self: center;
}
.about-content{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}
.footer-title{
	height: 1.25vw;
	font-family: MicrosoftYaHei;
	font-size: 1.25vw;
	font-weight: normal;
	font-stretch: normal;
	line-height: 2.08vw;
	letter-spacing: 0vw;
	color: #ffffff;
    padding-bottom: 2.68vw;
}
.footer-span{
	height: 1.92vw;
	font-family: MicrosoftYaHei;
	font-size: 0.85vw;
	font-weight: normal;
	font-stretch: normal;
	line-height: 1.28vw;
	letter-spacing: 0vw;
	color: #888e9f;
}
.footer-span-1{
    margin-top: 0.5vw;
    margin-left: 1vw;
    width: 27.45vw;
	height: auto;
}
.pict{
    width: 100%;
    height: auto;
}
.footer-title-1{
    margin-bottom: 3.18vw;
}
.hr-box{
    margin-top: 3.17vw;
    display: flex;
    align-items: center;
    justify-content: center;
}
.hr-line{
    width: 62.5vw;
	height: 0.05vw;
	background-color: #ffffff;
	opacity: 0.1;
}
.company-last-info{
    margin-top: 0.59vw;
    display: flex;
    align-items: center;
    justify-content: center;
	font-family: MicrosoftYaHei;
	font-size: 0.85vw;
	font-weight: normal;
	font-stretch: normal;
	line-height: 2.08vw;
	letter-spacing: 0vw;
	color: #888e9f;
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue